


import React, { useEffect, useRef, useState } from 'react';
import './transForm.scss';
import { Button, Stack } from '@mui/material';
import { COLORS, nameFormatter, output } from '../../settings/themeSettings';








const Transform = ({ onSubmit, entity, mandatories = [], toUpdate = null, onDelete = () => { }, onCancel = () => { } }) => {

    const [fields, setFields] = useState(Object.entries(entity));
    const [data, setData] = useState(entity);
    const [error, setError] = useState('');
    const formRef = useRef();

    const changeValue = (property, value) => {
        setData(prev => ({...prev, [property]: value}));
    }

    const formValidate = () => {
        let hasError = false;
        setError('');
        
        mandatories.forEach((item) => {
            const value = data[item];
            // Vérifie si la valeur est absente, nulle, ou une chaîne vide (après nettoyage des espaces)
            if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
                hasError = true;
            }
        });

        if (hasError) {
            setError("Veuillez remplir tous les champs obligatoires !");
            return;
        }

        onSubmit(data, () => {
            setData({...entity});
        });
    }

    useEffect(() => {
        if (!!toUpdate) {
            let update = Object.assign({}, data, toUpdate);
            output(update);
            setData(update);
            setFields(Object.entries(update));
        } else {
            setData({...entity});
            setFields(Object.entries(entity));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toUpdate, entity])

    return <div className='form-container'>

        <div className='form'>

            <form
                ref={formRef}
                onSubmit={(e) => {
                    e.preventDefault();
                    formValidate();
                }}
                onReset={(e) => {
                    e.preventDefault();
                    setData({...entity});
                    onCancel();
                }}
            >
                {
                    fields.map((field, idx) =>
                        (field[0] !== 'id') && (field[0] === "profil" ?
                            <div className="form-item" key={idx}>
                                <div className="label" style={{ textTransform: 'capitalize' }}> {nameFormatter(field[0]).toLowerCase()} <span> {mandatories.includes(field[0]) ? '*' : ''} </span> </div>
                                <select name={field[0]}
                                    value={data[field[0]] || ''}
                                    onChange={(e) => changeValue(field[0], e.target.value)} >
                                            <option value="ADMIN">ADMIN</option>
                                            <option value="ADMIN-PRODUCTION-BILLETTERIE">ADMIN-PRODUCTION-BILLETTERIE</option>
                                            <option value="ADMIN-PRODUCTION">ADMIN-PRODUCTION</option>
                                            <option value="ADMIN-BILLETTERIE">ADMIN-BILLETERIE</option>
                                            <option value="PRODUCTION">PRODUCTION</option>
                                            <option value="BILLETTERIE">BILLETTERIE</option>
                                        </select>

                            </div>
                            : <div className="form-item" key={idx}>
                                <div className="label" style={{ textTransform: 'capitalize' }}> {nameFormatter(field[0]).toLowerCase()} <span> {mandatories.includes(field[0]) ? '*' : ''} </span> </div>
                                <input type="text" name={field[0]}
                                    placeholder={nameFormatter(field[0])}
                                    value={data[field[0]] || ''}
                                    onChange={(e) => changeValue(field[0], e.target.value)} />

                            </div>
                        )
                    )
                }
                <div className="error-msg">
                    {!!error && error}
                </div>
                <Stack
                    direction='row'
                    justifyContent='space-between'
                >

                    <Button
                        color='error'
                        type='button'
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setData(entity);
                            onCancel();
                        }}
                        sx={{ border: '1px solid red', mt: 2, minWidth: '100px' }}
                    >
                        Annuler
                    </Button>

                    {!!toUpdate && <Button
                        color='error'
                        onClick={(e) => onDelete(data.id)}
                        sx={{ border: '1px solid red', mt: 2, minWidth: '100px' }}
                    >
                        supprimer
                    </Button>}


                    <Button
                        color='secondary'
                        // onClick={(e) => formValidate()}
                        type='submit'
                        sx={{ border: '1px solid' + COLORS.secondary, mt: 2, minWidth: '100px' }}
                    >
                        Enregistrer
                    </Button>
                </Stack>
            </form>
        </div>
    </div>;
}


export default Transform;
